import {
  CURRENT_VERSION,
  READ_RANGE_VERSIONED
} from "./chunk-7RQXHEKZ.js";

// src/encoding.ts
function encodeReadRangeWire(wire) {
  return READ_RANGE_VERSIONED.serializeWithEmbeddedVersion(
    wire,
    CURRENT_VERSION
  );
}
function decodeReadRangeWire(bytes) {
  return READ_RANGE_VERSIONED.deserializeWithEmbeddedVersion(bytes);
}
export {
  decodeReadRangeWire,
  encodeReadRangeWire
};
//# sourceMappingURL=encoding.js.map